import Service from "./Service";

class AdministrationApiService extends Service {
  constructor() {
    super("api/Administration");
  }

  async getTrainStations() {
    let result = await this.get(`/TrainStations`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new AdministrationApiService();
